export const ALWAYS_ENABLED_MODULES: string[] = [
  "permissions",
  "profiles",
  "notifications",
  "tags",
  "entity_tags",
  "pipeline_tracking",
  "platformsAndSessions",
];

/** Grupos de sistema que no deben aparecer en el editor de permisos por rol */
export const SYSTEM_ONLY_GROUPS = ["system"];
